import React, { useRef } from 'react';
import axios from "axios";

const tokenStr = localStorage.getItem('user');

const GalleryMediaForm = ({  user_id, toastifySuccess, setNewMediaId }) => {

  const fileInputRef = useRef(null);
  // Текст для popup
  const popupTextMediaSuccess = "Елемент галереї додано";

  const handleSubmit = (file) => {
      const url = process.env.REACT_APP_SERVER_URL + '/api/media_objects';
      const formData = new FormData();
      formData.append('file', file);
      formData.append('fileName', file.name);
      formData.append('name', file.name);
      
      if (user_id !== undefined)
        formData.append('user', user_id);
      // formData.append('name', name);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": `Bearer ${tokenStr}`
        },
      };

      axios.post(url, formData, config).then((response) => {
        // Popup про успішні зміни
        toastifySuccess(popupTextMediaSuccess);
        // Для стоінки media/
        setNewMediaId(response.data.id);
      }).catch(e => console.log(e));
  }

  function handleChange(event) {
    const file = event.target.files && event.target.files[0];
    if (file) {
      handleSubmit(file);
      // очистити значення, щоб повторний вибір того ж файлу тригерив onChange
      event.target.value = null;
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  }

  const handleClickDropzone = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const file = (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]) || null;

    if (file) {
      handleSubmit(file);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <>
      <div className='align-items-end'>
        <div
          className='mb-3'
          onDrop={handleDrop}
          onDragOver={handleDragOver}
        >
          <label
            className="gallery-upload-dropzone"
            onClick={handleClickDropzone}
          >
            <div className="gallery-upload-icon">⬆</div>
            <div className="gallery-upload-title">
              Drag &amp; drop images or <span className="gallery-upload-link">Browse</span>
            </div>
            <div className="gallery-upload-subtitle">
              Supported formats: .jpg, .png, .tiff
            </div>
          </label>
          <input
            className="gallery_file_control"
            id="formFileLg"
            type="file"
            onChange={handleChange}
            ref={fileInputRef}
          />
        </div>
      </div>
    </>
  );
}

export default GalleryMediaForm;